import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/availablePersonRoles', request)
}

export {get}
